// Relative times as the prototype (00-core.js rel()).
import { L, fDate, loc } from './prefs';

const MIN = 60_000, DAY = 86_400_000;
const sod = (t: number) => { const d = new Date(t); d.setHours(0, 0, 0, 0); return d.getTime(); };
const fTime = (t: number) => new Date(t).toLocaleTimeString(loc(), { hour: '2-digit', minute: '2-digit', hour12: false });
export function rel(at: number | string) {
  const t = typeof at === 'string' ? Date.parse(at) : at;
  const now = Date.now();
  const m = Math.round((now - t) / MIN);
  if (m >= 0 && m < 1) return L('just now', 'الآن');
  if (m > 0 && m < 60) return L(m + ' min ago', 'قبل ' + m + ' د');
  const dd = Math.round((sod(t) - sod(now)) / DAY);
  if (dd === 0) return L('today ', 'اليوم ') + fTime(t);
  if (dd === -1) return L('yesterday ', 'أمس ') + fTime(t);
  if (dd === 1) return L('tomorrow', 'غداً');
  if (dd < 0 && dd > -7) return L(-dd + ' days ago', 'قبل ' + -dd + ' أيام');
  if (dd > 0 && dd < 60) return L('in ' + dd + ' days', 'بعد ' + dd + ' يوماً');
  return fDate(t);
}
